module.exports = __webpack_public_path__ + "img/qinyan.9c5a16d5.jpg";